// #region Imports
import { defineComponent } from "vue";
import { DxCheckBox } from 'devextreme-vue/check-box';
import ProductConfigurator from '../manager/ProductConfigurator';
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-product-configurator',
    // #endregion
    // #region Components
    components: {
        DxCheckBox
    },
    // #endregion
    // #region Properties
    data: () => ({
        configurator: new ProductConfigurator(),
        configurationMode: '',
    }),
    props: {
        product: {
            type: Object,
            required: true,
            default: {}
        },
        currentItem: {
            type: Object,
            required: true,
            default: {}
        },
        entryData: {
            type: Object,
            required: true,
            default: {}
        },
    },
    // #endregion
    // #region Constructor
    created() {
        this.configurator = new ProductConfigurator();
    },
    beforeMount() {
        //Run
        if (this.product) {
            this.configurator.SetProduct(this.product, this.entryData.options);
            this.configurationMode = this.configurator.selectedScope ?? '';
        }
        if (this.currentItem) {
            this.configurator.setItem(this.currentItem);
        }
    },
    // #endregion
    // #region Watch
    watch: {
        'product': function (value) {
            this.configurator.SetProduct(this.product, this.entryData.options);
            this.configurationMode = this.configurator.selectedScope ?? '';
        },
        'currentItem': {
            handler(newValue, oldValue) {
                this.configurator.setItem(this.currentItem);
            },
            deep: true
        },
        '$data.configurationMode': function (value) {
            this.configurator.setScope(value);
        },
    },
    // #endregion
    // #region Core
    methods: {
        // #region Events
        handleValueChange(v, e) {
            // #region Check
            if (e.value) {
                return;
            }
            // #endregion
            v.selected = e.value;
        },
        // #endregion
    }
    // #endregion
});
// #endregion
